import React from 'react';
import Icon, { Logo } from 'components/Icon';
import { AuthenticationLayout } from 'components/Layout/AuthenticationLayout';
import { ContactForm } from 'components/Authentication/Forms';
import styles from './Contact.module.css';
import { PublicLayout } from '../Layout/PublicLayout';

export function Contact() {
  return (
    <PublicLayout 
      header={() => (
        <div>
          <img className='m-b' src='/images/icon-contact.svg' />
          <h1 className='h-color--white h-font--uppercase'>
            Get in touch with <br />
            <span style={{ color: 'var(--pale)'}}>Crystal</span> 
            <span style={{ color: 'var(--pale)', fontWeight: 100 }}>clear</span> 
          </h1>
          <p className='h-color--white'>
            Please get in touch for any questions
          </p>
        </div>
      )}
    >
        <ContactForm />
    </PublicLayout>

  );
}
